import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const NumberCircleOne: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m390 660c-72.12 0-139.92-28.08-190.92-79.08s-79.08-118.8-79.08-190.92 28.08-139.92 79.08-190.92 118.8-79.08 190.92-79.08 139.92 28.08 190.92 79.08 79.08 118.8 79.08 190.92-28.08 139.92-79.08 190.92-118.8 79.08-190.92 79.08zm0-510c-64.11 0-124.38 24.96-169.71 70.29s-70.29 105.6-70.29 169.71 24.96 124.38 70.29 169.71 105.6 70.29 169.71 70.29 124.38-24.96 169.71-70.29 70.29-105.6 70.29-169.71-24.96-124.38-70.29-169.71-105.6-70.29-169.71-70.29z' />
    <path d='m424.55 257.73v254.55h-30.82v-222.23h-1.49l-62.15 41.26v-31.32l63.64-42.26z' />
  </IconBase>
));

NumberCircleOne.displayName = 'NumberCircleOne';

export default NumberCircleOne;
